export interface AssetReportType {
    label: string;
    countField: string;
    datasourceId: string;
    filterKey: string;
}

export interface AssetProfile {
    keyField: string;
    keyLabel: string;
    nameField: string;
    labelFields: string[];
    customerField: string;
    customerLabel: string;
    homeField?: string;
    reportTypes: AssetReportType[];
}

const PDC_PROFILE: AssetProfile = {
    keyField: "AEIC",
    keyLabel: "AEIC",
    nameField: "UnitName",
    labelFields: ["UnitName", "UnitAbbreviation", "PlantName"],
    customerField: "Customer",
    customerLabel: "Customer",
    homeField: "source",
    reportTypes: [
        {
            label: "Exception Reports",
            countField: "ExceptionReportCount",
            datasourceId: "pdc_reports",
            filterKey: "AEIC",
        },
        {
            label: "Failed Sensor Reports",
            countField: "FailedSensorReportCount",
            datasourceId: "pdc_failed_sensor_reports",
            filterKey: "AEIC",
        },
        {
            label: "Field Service Reports",
            countField: "FieldServiceReportCount",
            datasourceId: "field_service_reports",
            filterKey: "AEIC",
        },
    ],
};

const GSD_PROFILE: AssetProfile = {
    keyField: "MachineNumber",
    keyLabel: "Serial Number",
    nameField: "StarmsTrainName",
    labelFields: ["StarmsTrainName", "MachineNumber"],
    customerField: "AccountName",
    customerLabel: "Account",
    reportTypes: [
        {
            label: "Salesforce Cases",
            countField: "SalesforceCaseCount",
            datasourceId: "salesforce",
            filterKey: "Machine No",
        },
        {
            label: "Field Service Reports",
            countField: "FieldServiceReportCount",
            datasourceId: "field_service_reports",
            filterKey: "Machine No",
        },
        {
            label: "RDS Reports",
            countField: "RdsReportCount",
            datasourceId: "rds_reports",
            filterKey: "Machine No",
        },
        {
            label: "RDS Notifications",
            countField: "RdsNotificationReportCount",
            datasourceId: "rds_notification_reports",
            filterKey: "Machine No",
        },
    ],
};

const ASSET_PROFILES: Record<string, AssetProfile> = {
    pdc_portal: PDC_PROFILE,
    gsd_core_products: GSD_PROFILE,
};

export const getAssetProfile = (datasourceId: string | undefined): AssetProfile | undefined =>
    datasourceId ? ASSET_PROFILES[datasourceId] : undefined;
